import Zepto from 'zepto-webpack'
import { Base64 } from 'js-base64'
import { uniqueId, isString } from 'underscore'
import CustomTextField from '@/host/custom/Text'
import CustomCheckboxField from '@/host/custom/Checkbox'
import CustomRadioField from '@/host/custom/Radio'

const getComponent = fieldType => {
  switch (fieldType) {
    case 'text':
      return CustomTextField
    case 'checkbox':
      return CustomCheckboxField
    case 'radio':
      return CustomRadioField
    default:
      return
  }
}

const getFieldType = $field => {
  const fieldType = $field.getAttribute('type')
  if (isString(fieldType)) {
    return fieldType.toLowerCase()
  } else {
    $field.setAttribute('type', 'text')
    return 'text'
  }
}

const encodeAttributes = field => {
  const attributes = Array.from(field.attributes).map(({ name, value }) => ({
    name,
    value
  }))

  return Base64.encodeURI(JSON.stringify(attributes))
}

const restoreAttributes = (field, appDiv) => {
  const encoded = appDiv.getAttribute('data-kr-custom-field-attributes')
  if (!encoded) return

  const decoded = Base64.decode(encoded)
  const attributes = JSON.parse(decoded)

  Array.from(field.attributes).forEach(({ name }) =>
    field.removeAttribute(name)
  )
  attributes.forEach(({ name, value }) => field.setAttribute(name, value))
}

const renderCustomField = $field => {
  const fieldType = getFieldType($field)
  const component = getComponent(fieldType)
  if (!component) return null

  // Create a single component dynamic
  const dynamicTag = uniqueId('kr-component-')
  component.$field = $field
  const field = Zepto($field)[0]

  // custom field was already mounted, app was unmounted but the html remains
  // using the existing app div, moving the  input.kr-theme as a slot to a new custom field component
  // removing the old custom field component markup KJS-6366
  const existingAppDiv = $field.closest('[data-kr-custom-field]')
  if (existingAppDiv) {
    // for text inputs the value attribute was kept in the dom causing issues
    restoreAttributes(field, existingAppDiv)
    const previousCustomField = existingAppDiv.firstElementChild
    const newCustomField = document.createElement('component')
    newCustomField.setAttribute('is', dynamicTag)
    newCustomField.appendChild(field)
    existingAppDiv.appendChild(newCustomField)
    previousCustomField.remove()

    return {
      name: dynamicTag,
      component: { ...component, $field: field }
    }
  }
  // Create app wrapper
  const appId = uniqueId('kr-field-app-')
  const appDiv = document.createElement('div')
  const customField = document.createElement('component')
  customField.setAttribute('is', dynamicTag)

  appDiv.id = appId
  appDiv.setAttribute('data-kr-custom-field', '')
  appDiv.setAttribute(
    'data-kr-custom-field-attributes',
    encodeAttributes(field)
  )
  appDiv.appendChild(customField)

  field.parentNode.insertBefore(appDiv, field.nextSibling)
  field.parentNode.removeChild(field)
  customField.appendChild(field)

  return {
    name: dynamicTag,
    component: { ...component, $field: field }
  }
}

/**
 * Prepare merchant fields for rendering by the main Vue application.
 *
 * @returns {Record<string, object>}
 */
export default $wrapper => {
  const customComponents = {}
  const $customFields = $wrapper[0].querySelectorAll('input.kr-theme') || []

  // for..of of domElements has no iterablity
  for (let i = 0; i < $customFields.length; i++) {
    const customField = renderCustomField($customFields[i])
    if (customField) {
      customComponents[customField.name] = customField.component
    }
  }

  return customComponents
}
